export interface DetailplanningModel {
  id: string;
  plancategorieId: string;
  jaartal: number;
  aantalGepland: number;
}
